import { render, staticRenderFns } from "./TermsPresentation.vue?vue&type=template&id=5eaba7bf&"
import script from "./TermsPresentation.vue?vue&type=script&lang=js&"
export * from "./TermsPresentation.vue?vue&type=script&lang=js&"
import style0 from "./TermsPresentation.vue?vue&type=style&index=0&id=5eaba7bf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports